<!-- eslint-disable vue/multi-word-component-names -->
<script>
  export default {
    name: 'RecursiveField',
    props: {
      cols: {
        type: Number,
        required: false,
        default: 3,
      },
      data: {
        type: Array,
        required: true,
        default: () => [],
      },
      hint: {
        type: String,
        required: true,
        default: '',
      },
      level: {
        type: Number,
        required: true,
        default: 0,
      },
      globalFieldName: {
        type: String,
        required: true,
        default: 'placeCategory',
      },
    },
    data() {
      return {
        fieldValue: null,
        textValue: '',
      };
    },
    computed: {
      recursiveFieldData: function () {
        return [...this.data]?.find(({ value }) => this.fieldValue === value)?.data;
      },
      isTextField: function () {
        return [...this.data]
          ?.find(({ value }) => this.fieldValue === value)
          ?.value?.toString()
          ?.includes('سایر');
      },
      _level: function () {
        return this.level + 1;
      },
    },
    watch: {
      fieldValue: {
        handler(currentVal) {
          if (currentVal) {
            const newField = {
              value: currentVal,
              fieldName: this.globalFieldName,
              level: this.level,
            };
            this.$store.dispatch('setNewFieldDispatch', newField);
          }
        },
        immediate: true,
      },
      textValue: {
        handler(currentVal) {
          if (currentVal) {
            const newField = {
              value: currentVal,
              fieldName: this.globalFieldName,
              level: this._level,
            };
            this.$store.dispatch('setNewFieldDispatch', newField);
          }
        },
        immediate: true,
      },
      '$store.state.recursiveFieldModule.loadedFieldsArr': {
        handler(currentVal) {
          if (currentVal?.length && !this.textValue && !this.fieldValue) {
            const key = `${this.globalFieldName}${this.level}`;
            const fieldVal = [...currentVal]?.find((value) => Object.keys(value)[0] === key)?.[key];
            this.fieldValue = fieldVal;
            if (fieldVal === 'سایر') {
              const nextLevelKey = `${this.globalFieldName}${this._level}`;
              const textValue = [...currentVal]?.find(
                (value) => Object.keys(value)[0] === nextLevelKey,
              )?.[nextLevelKey];
              this.textValue = textValue;
              this.$store.dispatch('clearLoadedDataDispatch');
              return;
            }
            if (this.level === currentVal?.length - 1)
              this.$store.dispatch('clearLoadedDataDispatch');
          }
        },
        immediate: true,
      },
    },
  };
</script>
<template>
  <!-- <v-col> -->
  <!-- <v-row no-gutters> -->
  <v-row no-gutters class="gap-2">
    <div>
      <v-autocomplete
        v-if="data?.length"
        :items="data"
        no-data-text="اطلاعاتی وجود ندارد"
        dense
        outlined
        clear-icon="mdi-close-circle-outline"
        item-text="value"
        item-value="value"
        prepend-inner-icon="mdi-road-variant mdi-18px"
        :label="hint"
        v-model="fieldValue"
      ></v-autocomplete>
    </div>
    <div v-if="recursiveFieldData?.length">
      <recursive-field
        :data="recursiveFieldData"
        :hint="recursiveFieldData?.[0]?.hint"
        :cols="4"
        :level="_level"
        :globalFieldName="globalFieldName"
      />
    </div>
    <div v-if="isTextField">
      <v-text-field
        dense
        outlined
        clearable
        clear-icon="mdi-close-circle-outline"
        prepend-inner-icon="mdi-road-variant mdi-18px"
        label="سایر"
        v-model="textValue"
      ></v-text-field>
    </div>
  </v-row>
</template>
